<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="searchFormComponent"
        tourists-label="guest"
        show-dates
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import ActivitySearchForm from '~src/components/activities/search/forms/activitySearchForm.src'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            ActivitySearchForm,
        },
    })
    export class ActivitySearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        searchForm = false

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get searchFormComponent() {
            return resolveComponent('ActivitySearchForm')
        }

        get isSearchActive() {
            return activitiesRuntimeStore.searchActive
        }

        get activitiesRuntimeStore() {
            return activitiesRuntimeStore
        }

        get locationLabel() {
            if (activitiesRuntimeStore.country?.name && !activitiesRuntimeStore.city?.name) {
                return `${activitiesRuntimeStore.country.name}`
            }

            return `${activitiesRuntimeStore.city.name}, ${activitiesRuntimeStore.city.parentName}`
        }

        checkDisabled(on) {
            if (this.searchDisabled) return
            return on
        }
    }

    export default ActivitySearchSummary
</script>
